import * as types from './types'

/* admin_localities */

export const getLocalitiesRequest = () => ({
  type: types.GET_ADMIN_LOCALITIES_REQUEST,
})
export const getLocalitiesSuccess = (result) => ({
  type: types.GET_ADMIN_LOCALITIES_SUCCESS,
  payload: result,
})
export const getLocalitiesError = (error) => ({
  type: types.GET_ADMIN_LOCALITIES_ERROR,
  payload: error,
})
